import { connect } from 'react-redux';
import Sidebar from 'components/layout/Sidebar';

const mapStateToProps = (state, ownProps) => {
  return {
    location: state.routing.locationBeforeTransitions || {},

    partyTypes: state.app.lookups.partyTypes,

    user: state.app.user,

    menuOpen: state.app.menuDropdownOpen === true,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Sidebar);
